import { render, staticRenderFns } from "./BaseSetPoint.vue?vue&type=template&id=4e9b7870"
import script from "./BaseSetPoint.vue?vue&type=script&lang=js"
export * from "./BaseSetPoint.vue?vue&type=script&lang=js"
import style0 from "./BaseSetPoint.vue?vue&type=style&index=0&id=4e9b7870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports